module.exports = __webpack_public_path__ + "static/bebas-54972aef0041e17d2f1d191e40e7b583.ttf";